import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToysBuilding = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "toys-building" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 3.994,
			y: 17.625,
			width: 9,
			height: 5.25,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 3.994,
			y: 12.375,
			width: 9,
			height: 5.25,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .994,
			y: 7.125,
			width: 9,
			height: 5.25,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 3.994,
			y: 1.875,
			width: 9,
			height: 5.25,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 19.478,
			y1: 11.727,
			x2: 20.988,
			y2: 22.875
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 15.375,
			y: 6.501,
			width: 7.5,
			height: 5.25,
			rx: 1.5,
			ry: 1.5,
			transform: "translate(-1.052 2.651) rotate(-7.718)"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.744,
			y1: 3.375,
			x2: 16.744,
			y2: 1.125
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 19.744,
			y1: 4.125,
			x2: 21.244,
			y2: 2.625
		})
	]
});
export default SvgToysBuilding;
